import axios from 'axios';

export default class DynamicFormService
{
    public static async getAutocompleteList(search: string, limit: number = 10): Promise<ListItemModel[]>
    {
        return (await axios.get<ListItemModel[]>('admin/core/forms/autocomplete', {
            params: {
                search: search,
                limit: limit
            }
        })).data;
    }

    public static async fetchAutocompleteModel(id: number): Promise<ListItemModel>
    {
        return (await axios.get<ListItemModel>(`admin/core/forms/autocomplete/${id}`)).data;
    }
}

export interface ListItemModel
{
    id: number;
    title: string;
    originId: number;
}
